import { render, staticRenderFns } from "./SocialMediaShare.vue?vue&type=template&id=52db6ea8&scoped=true"
import script from "./SocialMediaShare.vue?vue&type=script&lang=js"
export * from "./SocialMediaShare.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaShare.vue?vue&type=style&index=0&id=52db6ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db6ea8",
  null
  
)

export default component.exports